import { useQuery } from 'react-query'
import { AxiosInstance } from 'axios'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'

import {
  Assignment,
  GetAssignmentsResponse,
} from '@dc-shared-web/hooks/api/assignment/types'

export const fetchAssignments = async (
  apiClient: AxiosInstance,
  params: {
    checklist_data_uuid?: string
    crunch_uuid?: string
  }
): Promise<Assignment[]> => {
  const response = await apiClient.get<GetAssignmentsResponse>(
    '/api/assignments',
    {
      params: {
        ...params,
        limit: 100,
      },
    }
  )
  return response.data.results
}

export const useGetAssignments = ({
  checklist_data_uuid,
  crunch_uuid,
  enabled,
}: {
  checklist_data_uuid?: string
  crunch_uuid?: string
  enabled?: boolean
}) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<Assignment[], Error>({
    queryKey: ['assignments', checklist_data_uuid, crunch_uuid],
    queryFn: () =>
      fetchAssignments(apiClient, {
        checklist_data_uuid,
        crunch_uuid,
      }),
    enabled,
  })
}
